/**
 * @imports
 */
import React, { Fragment } from 'react'
import { message, Table, Button, Popconfirm, Icon, Tooltip, Tag, Divider } from 'antd'
import moment from 'moment'
import Cell from '../../../components/Cell'
import Api from '../../../Api'
import Exception from '../../../Exception'
import Colors from '../../../Colors'

/**
 *
 * @param {*} props
 * @returns
 */
export function SubSolicitudPagoAdjuntos(props) {
  const [loading, setLoading] = React.useState(false)
  const [isPending, setIsPending] = React.useState(true)
  const [templates, setTemplates] = React.useState([])
  const [solicitudId, setSolicitudId] = React.useState(props.registroId || 0)
  const [data, setData] = React.useState([])

  const getRecordAceptado = (record) => {
    return !record.iAceptado && !record.iRechazado ? null : (
      record.iAceptado || !record.iRechazado
    )
  }

  const columns = Cell.buildList([
    { title: 'DOCUMENTO', dataIndex: 'documento.sNombre', width: 330,
      render: (val, record) => <div style={{ display: 'flex' }}>
        <div style={{ minWidth: 40 }}>
          {record.documento && record.root === true
            ? <Fragment>
              <Button
                size='small'
                icon='plus'
                onClick={() => requestNewFile(record.documento)}
              />

              <Divider type='vertical' />
            </Fragment>
            : <div children=' ' />
          }
        </div>

        {record.documento
          ?
            <Tag
              color={record.documento.requerido
                ? 'volcano'
                : undefined
              }
              children={record.documento.requerido
                ? 'REQUERIDO'
                : 'OPCIONAL'
              }
            />
          : null
        }
        <span style={{ marginRight: 5 }}>{val}</span>
      </div>
    },

    { title: 'NOMBRE', dataIndex: 'dFecha', width: 200,
      render: (_, record) =>
        record.archivo
          ? <a
            href={Api.to(`/upload/file/${record.iIdArchivo}`)}
            download={record.archivo.sDescripcion}
            children={record.archivo.sDescripcion}
          />
          : null
    },
    { title: 'FECHA', dataIndex: 'dFecha', width: 150, render: val => val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '' },
    { title: 'STATUS', dataIndex: 'sComentario', width: 150,
      render: (comentario, record) => {
        if (!record.archivo) {
          return null
        }

        const status = getRecordAceptado(record)

        return (
          <div style={{ display: 'flex' , flexDirection: 'row', alignItems: 'center' }}>
            <Icon
              type={status !== null ?
                (status ? 'check' : 'close') :
                'clock-circle'
              }
              style={{
                fontSize: 16,
                color: status === null ?
                  'inherit' :
                  (status ?
                    Colors.success :
                    (record.iAceptado == null ?
                      Colors.warning :
                      Colors.error
                    )
                  ),
              }}
            />

            <span style={{ marginLeft: 5 }}>{status !== null ? comentario : (isPending ? 'ELABORANDO' : 'EN REVISIÓN')}</span>
          </div>
        )
      }
    },
    { title: 'ACCIONES', dataIndex: 'dFecha', width: 100,
      render: (_, record) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {!isPending || !record.archivo ? null : (
              <Popconfirm title='¿Eliminar?' onConfirm={() => setAdjItem(record, { iActivo: false })}>
                <Button size='small' icon='delete' />
              </Popconfirm>
            )}

            {record.iRechazado !== true ? null : (
              <Tooltip title='Subir nueva revisión'>
                <Button size='small' icon='upload' onClick={() => newVersion(record)} />
              </Tooltip>
            )}
          </div>
        )
      }
    },
  ].concat(!isPending ? [] : [

  ]))

  /**
   *
   * @param {*} loadId
   */
  const load = (loadId, requerido) => {
    setLoading(true)
    setTemplates([])
    setSolicitudId(loadId)
    setData([])

    const query = {
      documentos: {
        model: 'AppDocumento'
      },

      requeridos: {
        model: 'CmrDocumentoRequerido',
        attributes: ['iIdDocumento'],
        include: [{
          required: true,
          association: 'modelo',
          attributes: [],
          where: { sNombre: requerido.modelo }
        }],
        where: {
          iActivo: true,
          iIdRegistro: loadId,
          sReferencia: requerido.referencia,
        }
      },

      adjuntos: {
        model: 'KernelAdjunto',
        attributes: [
          'iId',
          'iIdModelo',
          'iIdRegistro',
          'iIdAdjunto',
          'iIdKernelUsuarioRegistra',
          'dKernelFechaRegistro',
        ],
        include: [
          {
            as: 'modelo',
            required: true,
            attributes: [],
            where: { sNombre: requerido.modelo }
          },
          {
            as: 'archivo',
            required: true,
            attributes: ['sDescripcion']
          },
          {
            as: 'registra',
            required: true,
            attributes: ['sNombre']
          },
        ],
        where: {
          iIdRegistro: loadId,
          iActivo: true
        }
      },

      adjuntosStatus: {
        attributes: [
          'iId',
          'dFecha',
          'iIdAdjunto',
          'iIdArchivo',
          'iIdDocumento',
          'iAceptado',
          'iRechazado',
          'sComentario'
        ],
        model: 'SubOrdenPagoAdjunto',
        include: [
          { as: 'archivo', attributes: ['sDescripcion'] },
          { as: 'documento', attributes: ['sNombre'] }
        ],
        where: {
          [requerido.campo]: loadId,
          // iIdUsuario: null,
          iActivo: true
        },
      },

      solicitud: {
        __returnType: 'one',
        model: requerido.modelo,
        attributes: ['sEstado', 'iIdUsuarioSolicita'],
        where: { iId: loadId },
      }
    }

    const esSolicitudPago = requerido.modelo === 'SubOrdenPago'
    const esEstimacion = requerido.modelo === 'SubEstimacion'

    if (esEstimacion) {
      query.solicitud.attributes = [['sStatus', 'sEstado'], 'iIdUsuarioSolicita']
    }

    Api.query.list(query)
      .then(response => {
        const elaborando =
          (
            esSolicitudPago
            || response.data.solicitud.iIdUsuarioSolicita === null
          ) && (
            (
              esSolicitudPago
              && response.data.solicitud.sEstado === 'ELABORANDO'
            ) || (
              esEstimacion
              && response.data.solicitud.sEstado === 'PENDIENTE'
            )
          )

        const en_revision =
          response.data.solicitud.sEstado === 'EN REVISION'
          && (
            esSolicitudPago
            || response.data.solicitud.iIdUsuarioSolicita !== null
          )

        setIsPending(elaborando)
        setLoading(false)
        const nextTemplates = (elaborando || en_revision ? response.data.documentos : [])
          .map(doc => {
            doc.requerido = response.data.requeridos.find(
              item => item.iIdDocumento === doc.iId
            ) ? true : undefined

            return doc
          })
          .sort((d) => d.requerido ? -1 : 0)

        setTemplates(nextTemplates)

        const files = response.data.adjuntos
          .map(item => item.iIdAdjunto)
          .concat(response.data.adjuntosStatus.map(item => item.iIdArchivo))
          .filter((val, idx, arr) => arr.indexOf(val) === idx)
          .map(fileId => {
            const status = response.data.adjuntosStatus.find(item => item.iIdArchivo === fileId)
            const attachment = response.data.adjuntos.find(item => item.iIdAdjunto === fileId)
            return status || attachment
          })

        setData(files)
      })
      .catch(error => {
        setLoading(false)
        Exception.load(error).show()
      })
  }

  /**
   *
   * @param {*} file
   * @param {*} template
   */
  const uploadFile = async (file, template) => {
    const closeMessage = message.loading('Cargando', 0)
    setLoading(true)

    // actualizar la ui
    const closeLoadings = () => {
      setLoading(false)
      closeMessage()
    }

    try {
      const upload = await Api.post('/upload/file',
        Api.form({ upload: file, tipo: `WEB.UPLOAD` })
      )

      const payload = {
        model: 'SubOrdenPagoAdjunto',
        values: {
          [props.requerido.campo]: solicitudId,
          iIdDocumento: template.iId,
          iIdArchivo: upload.data.iId,
        }
      }

      const res = await Api.post('/kernel/mutator', payload)
      if (!res.data.ok) { throw new Error(res.data.error) }

      closeLoadings()
      message.success('Listo')
      load(solicitudId, props.requerido)
    } catch (err) {
      closeLoadings()
      Exception.load(err).show()
    }
  }

  /**
   *
   * @param {*} template
   * @returns
   */
  const requestNewFile = (template) => {
    if (!template) {
      return
    }

    var input = document.createElement('input')
    input.type = 'file'
    input.accept = template.sFiltro
    input.onchange = e => {
      if (input.files.length > 0) {
        uploadFile(input.files[0], template)
      }
      input.value = null
    }

    input.click()
  }

  /**
   *
   * @param {*} record
   */
  const setAdjItem = (record, values) => {
    setLoading(true)

    const payload = {
      model: 'SubOrdenPagoAdjunto',
      id: record.iId,
      values,
    }

    return Api.post('/kernel/mutator', payload)
      .then(() => {
        message.success('Actualizado')
        setLoading(false)

        if (values && values.iActivo === false) {
          setData(data.filter(item => item.iId !== record.iId))
        }

        return Promise.resolve()
      })
      .catch(error => {
        setLoading(false)
        Exception.load(error).show()
      })
  }

  /**
   *
   * @param {*} adj
   */
  const newVersion = (adj) => {
    setAdjItem(adj, { iAceptado: null })
      .then(() =>
        requestNewFile(templates.find(t => t.iId.toString() === adj.iIdDocumento.toString()))
      )
  }

  React.useEffect(() => {
    if (props.registroId) {
      load(props.registroId, props.requerido)
    }
  }, [props.registroId, props.requerido])

  const documentos = templates
  const records = data
  const nextRecords = []

  // documentos posibles
  nextRecords.push(
    ...documentos.reduce((acc, doc) => {
      const adjuntados = records
        .filter(record => record.iIdDocumento === doc.iId)
        .map(record => {
          record.documento = doc
          return record
        })

      if (adjuntados.length > 0) {
        adjuntados[0].root = true
        acc.push(...adjuntados)
      } else if (isPending) {
        acc.push({
          iId: 'doc-' + doc.iId,
          iIdModelo: null,
          iIdRegistro: null,
          iIdAdjunto: null,
          iIdKernelUsuarioRegistra: null,
          dKernelFechaRegistro: null,
          documento: doc,
          root: true,
        })
      }
      return acc
    }, [])
  )

  // adjuntos sin etiquetar
  nextRecords.push(
    ...records.reduce((acc, record) => {
      if (!record.iIdDocumento) {
        acc.push(record)
      }

      return acc
    }, [])
  )

  return <Table
    rowKey='iId'
    size='small'
    loading={loading}
    columns={columns}
    pagination={false}
    dataSource={nextRecords}
    bordered={false}
  />
}
